import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../components/Toast';

export default function ProfilePage() {
  const { user, profile, company, refreshProfile } = useAuth();
  const { showToast } = useToast();
  const [fullName, setFullName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setFullName(profile?.full_name ?? '');
  }, [profile?.full_name]);

  const saveProfile = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!profile) return;
    setSaving(true);
    try {
      await api.patch('/api/profile', { full_name: fullName.trim() || null });
      await refreshProfile();
      showToast('Profile updated.', 'success');
    } catch (err: any) {
      showToast(err.message || 'Failed to update profile.', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Profile</h1>
      </div>

      <div className="form-card" style={{ maxWidth: 760 }}>
        <form onSubmit={saveProfile}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" value={user?.email ?? ''} disabled />
            </div>
            <div className="form-group">
              <label className="form-label">Role</label>
              <input className="form-input" value={profile?.role ?? ''} disabled />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Company</label>
              <input className="form-input" value={company?.name ?? ''} disabled />
            </div>
            <div className="form-group">
              <label className="form-label">Invite Code</label>
              <input className="form-input" value={company?.invite_code ?? ''} disabled />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="fullName">Full Name</label>
            <input
              id="fullName"
              className="form-input"
              placeholder="Enter your full name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>

          <div className="form-actions">
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? <><span className="btn-spinner" /> Saving...</> : 'Save Profile'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
